import React, { useState, useEffect, useRef } from 'react'
import Icon from 'components/Icon'
import Portal from 'components/Portal'

import { usePopper } from 'react-popper'

const chunk = (arr, size) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size)
  )

const DropdownNavItem = ({ children, items, cols = 1 }) => {
  const [visible, setVisibility] = useState(false)
  const referenceElement = useRef(null)
  const popperElement = useRef(null)

  const toggle = (event) => setVisibility(!visible)

  const onOutsideClick = (event) => {
    if (
      popperElement.current &&
      (popperElement.current.contains(event.target) ||
        referenceElement.current.contains(event.target))
    ) {
      return
    }

    setVisibility(false)
  }

  useEffect(() => {
    document.addEventListener('mousedown', onOutsideClick)
    return () => {
      document.removeEventListener('mousedown', onOutsideClick)
    }
  }, [])

  const { styles, attributes } = usePopper(
    referenceElement.current,
    popperElement.current,
    {
      placement: 'bottom-start',
    }
  )

  const chunks = chunk(items, cols)

  return (
    <React.Fragment>
      <div
        className="group block md:inline-block py-6 px-4 text-white hover:text-primary text-base hover:bg-white transition duration-150 ease-in-out cursor-pointer block whitespace-nowrap"
        onMouseEnter={() => setVisibility(true)}
        onMouseLeave={() => setVisibility(false)}
        ref={referenceElement}
      >
        {children}

        <span className="pl-2">
          <Icon icon="angle-down" className="group-hover:rotate-180" />
        </span>
      </div>

      <Portal>
        <div ref={popperElement} style={{ ...styles.popper, zIndex: 50 }} {...attributes.popper}>
          <div
            onMouseLeave={() => setVisibility(false)}
            onMouseEnter={() => setVisibility(true)}
            className={`shadow-xl bg-white text-sm grid grid-cols-${cols} ${
              visible ? 'block' : 'hidden'
            }`}
          >
            {chunks.map((components, outer) => (
              <div className="w-64 " key={outer}>
                {components.map((component, inner) => (
                  <div
                    className="block border-b border-gray-100 px-4 py-5 text-gray-800 text-base group hover:text-primary-lighter cursor-pointer"
                    key={`${outer}-${inner}`}
                  >
                    <div className="transform duration-150 group-hover:translate-x-2">
                      {component}
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </Portal>
    </React.Fragment>
  )
}

export default DropdownNavItem
